import React from 'react';
import Icon from 'components/commons/icon/Icon';
import { StuffingType } from '../home/Home';

type TabDomainProps = {
  setStuffingType: React.Dispatch<React.SetStateAction<StuffingType>>;
  stuffingType: StuffingType;
};
export type TabProps = TabDomainProps & Record<string, unknown>;
type TabItemDomainProps = {
  onClick: () => void;
  isActive: boolean;
};
type TabItemProps = TabItemDomainProps & {
  title: string;
  iconName: TabIconName;
  TotalAssetorNot?: boolean;
};
type TabIconName = 'area-graph' | 'website' | 'timeline' | 'chart-pie';
const TabItem = ({
  title,
  iconName,
  isActive,
  onClick,
  TotalAssetorNot,
}: TabItemProps): React.ReactElement => {
  return (
    <>
      <div
        className={`w-full h-full text-xs font-bold px-1 pt-1 cursor-pointer`}>
        <div
          id={`${
            iconName === 'area-graph' && TotalAssetorNot
              ? 'home_assets'
              : iconName === 'area-graph' && !TotalAssetorNot
              ? 'home_assets_group'
              : iconName === 'website' && TotalAssetorNot
              ? 'home_positions'
              : iconName === 'website' && !TotalAssetorNot
              ? 'home_positions_group'
              : iconName === 'timeline' && TotalAssetorNot
              ? 'home_profitOrLoss'
              : iconName === 'chart-pie' && TotalAssetorNot
              ? 'home_portfolio'
              : iconName === 'chart-pie' && !TotalAssetorNot
              ? 'home_portfolio_group'
              : ''
          }`}
          className={`flex justify-center items-center flex-col flex-1 h-full text-white ${
            isActive ? '' : 'text-gray-500'
          }`}
          onClick={onClick}>
          <Icon
            className={`${
              isActive ? 'text-white' : 'text-gray-500'
            } text-base mb-0.5`}
            name={iconName}
          />
          <div className="leading-5">{title}</div>
          <div
            className={`${isActive ? 'bg-white w-full pt-0.5 mt-0.5' : 'mt-1'}`}
            style={{ borderRadius: '1px 1px 0 0' }}></div>
        </div>
      </div>
    </>
  );
};

type tabItemsListProps = {
  title: string;
  name: TabIconName;
  stuffingType: StuffingType;
};

const tabItemsList: tabItemsListProps[] = [
  {
    title: '資産',
    name: 'area-graph',
    stuffingType: '資産',
  },
  {
    title: '保有資産',
    name: 'website',
    stuffingType: '保有資産',
  },
  {
    title: '損益',
    name: 'timeline',
    stuffingType: '損益',
  },
  {
    title: 'ﾎﾟｰﾄﾌｫﾘｵ',
    name: 'chart-pie',
    stuffingType: 'ポートフォリオ',
  },
];
const Tab = ({
  stuffingType,
  setStuffingType,
  items,
}: TabProps & { items: tabItemsListProps[] }): React.ReactElement => {
  const TotalAssetorNot = items.length === 4 ? true : false;
  return (
    <>
      <div className="h-12 absolute left-0 w-full max-w-md -top-6 px-4 z-10">
        <div className="flex h-full rounded-full bg-bluegray-700 px-7">
          {items.map((item, i) => (
            <TabItem
              iconName={item.name}
              key={i}
              isActive={stuffingType === item.stuffingType}
              title={item.title}
              onClick={(): void => setStuffingType(item.stuffingType)}
              TotalAssetorNot={TotalAssetorNot}
            />
          ))}
        </div>
      </div>
    </>
  );
};
export const TotalAssetTab = (props: TabProps): React.ReactElement => {
  const items = tabItemsList;
  return <Tab {...props} {...{ items }} />;
};
export const GroupAssetTab = (props: TabProps): React.ReactElement => {
  const items = tabItemsList.filter(item => item.stuffingType !== '損益');
  return <Tab {...props} {...{ items }} />;
};
